/* eslint-disable max-len */
import * as React from 'react';

const Financial = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 4.75C5.16848 4.75 4.85054 4.8817 4.61612 5.11612C4.3817 5.35054 4.25 5.66848 4.25 6C4.25 6.33152 4.3817 6.64946 4.61612 6.88388C4.85054 7.1183 5.16848 7.25 5.5 7.25H18.75V4.75H5.5ZM20.25 7.25V4C20.25 3.58579 19.9142 3.25 19.5 3.25H5.5C4.77065 3.25 4.07118 3.53973 3.55546 4.05546C3.03973 4.57118 2.75 5.27065 2.75 6V20C2.75 20.7293 3.03973 21.4288 3.55546 21.9445C4.07118 22.4603 4.77065 22.75 5.5 22.75H21.5C21.9142 22.75 22.25 22.4142 22.25 22V17.75H22.5C22.9142 17.75 23.25 17.4142 23.25 17V13C23.25 12.5858 22.9142 12.25 22.5 12.25H22.25V8C22.25 7.58579 21.9142 7.25 21.5 7.25H20.25ZM5.5 8.75C5.06137 8.75 4.63355 8.64521 4.25 8.44949V20C4.25 20.3315 4.3817 20.6495 4.61612 20.8839C4.85054 21.1183 5.16848 21.25 5.5 21.25H20.75V17.75H18.5C17.7707 17.75 17.0712 17.4603 16.5555 16.9445C16.0397 16.4288 15.75 15.7293 15.75 15C15.75 14.2707 16.0397 13.5712 16.5555 13.0555C17.0712 12.5397 17.7707 12.25 18.5 12.25H20.75V8.75H5.5ZM18.5 13.75C18.1685 13.75 17.8505 13.8817 17.6161 14.1161C17.3817 14.3505 17.25 14.6685 17.25 15C17.25 15.3315 17.3817 15.6495 17.6161 15.8839C17.8505 16.1183 18.1685 16.25 18.5 16.25H21.75V13.75H18.5Z"
      fill="#D1D1D1"
    />
  </svg>
);

export default Financial;
